import React, { useRef, cloneElement } from 'react';
import classNames from 'classnames';
import { hasPrefixSuffix, hasAddon } from './utils';
const BaseInput = (props) => {
    const { inputElement: inputEl, addonBefore, addonAfter, prefix, suffix, allowClear, disabled, readOnly, components, value, containerClassName, children } = props;
    const inputElement = children ?? inputEl;
    // ======================== Components ======================== //
    const AffixWrapperComponent = components?.affixWrapper || 'div';
    const GroupWrapperComponent = components?.groupWrapper || 'div';
    const WrapperComponent = components?.wrapper || 'div';
    const GroupAddonComponent = components?.groupAddon || 'div';
    // ======================== Refs ======================== //
    const containerRef = useRef(null);
    const groupRef = useRef(null);
    let element = cloneElement(inputElement, {
        className: classNames({
            'base-input': true,
            [`${inputElement.props.className}`]: inputElement.props.className,
        }),
    });
    // ======================== Prefix && Suffix ======================== //
    if (hasPrefixSuffix(props)) {
        let clearIcon = null;
        if (allowClear) {
            const needClear = !disabled && !readOnly && !!value;
            const clearIconCls = 'clear-icon';
            const iconNode = typeof allowClear === 'object' && allowClear?.clearIcon ? allowClear.clearIcon : '✖';
            clearIcon = (React.createElement("span", { 
                // onClick={(event) => {
                //     handleReset?.(event);
                //     onClear?.();
                // }}
                onMouseDown: (e) => e.preventDefault(), role: 'button', tabIndex: -1, className: classNames(clearIconCls, {
                    [`${clearIconCls}-hidden`]: !needClear,
                    [`${clearIconCls}-has-suffix`]: !!suffix,
                }) }, iconNode));
        }
        const suffixNode = (suffix || allowClear) && (React.createElement("span", null,
            clearIcon,
            suffix));
        element = (React.createElement(AffixWrapperComponent, { ref: containerRef, className: 'affix-wrapper' },
            prefix && React.createElement("span", null, prefix),
            element,
            suffixNode));
    }
    // ======================== Addon (Before && After) ======================== //
    if (hasAddon(props)) {
        element = (React.createElement(GroupWrapperComponent, { className: 'group-wrapper', ref: groupRef },
            React.createElement(WrapperComponent, null,
                addonBefore && React.createElement(GroupAddonComponent, null, addonBefore),
                element,
                addonAfter && React.createElement(GroupAddonComponent, null, addonAfter))));
    }
    const classString = classNames('base-input-container', {
        [containerClassName]: containerClassName,
    });
    return (React.createElement("div", { className: classString }, cloneElement(element, {
        className: classNames({
            [element.props.className]: element.props.className,
        }),
    })));
};
if (process.env.NODE_ENV !== 'production') {
    BaseInput.displayName = 'BaseInput';
}
export default BaseInput;
//# sourceMappingURL=index.js.map